import SessionService from './session-service';

class AjaxCommonsImpl {
  private static readonly PORT = 80;

  private headers: Headers;

  constructor(private sessionService = SessionService) {
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
  }

  public get(path: string) {
    return fetch(`${this.getUrl()}get.php?${path}&session=${this.sessionService.get()}`, {
      method: 'GET',
    }).then(result => {
      return result.json().then(json => {
        if (json.result && json.result === 'Unauthorized') {
          window.location.href = '/';
          return Promise.reject('Unauthorized');
        }
        return Promise.resolve(json);
      });
    });
  }

  public post(path: string, body: any = {}, page: 'put' | 'get' | 'delete' = 'get') {
    return fetch(this.getUrl() + page + '.php?' + path, {
      method: 'POST',
      body: this.formEncode({
        ...body,
        session: this.sessionService.get(),
      }),
      headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    }).then(result => {
      return result.json();
    });
  }

  public file(path: string, formData: FormData) {
    return fetch(this.getUrl() + 'upload.php?' + path + '&session=' + this.sessionService.get(), {
      method: 'POST',
      body: formData,
    });
  }

  public getGalleryUrl = () => {
    if (process.env.VUE_APP_PORT === '0') {
      return (
        window.location.protocol +
        '//' +
        window.location.hostname +
        process.env.VUE_APP_GALLERY
      );
    }
    return (
      window.location.protocol +
      '//' +
      window.location.hostname +
      ':' +
      process.env.VUE_APP_PORT +
      process.env.VUE_APP_GALLERY
    );
  }

  private getUrl = () => {
    if (process.env.VUE_APP_PORT === '0') {
      return (
        window.location.protocol +
        '//' +
        window.location.hostname +
        process.env.VUE_APP_URL
      );
    }
    return (
      window.location.protocol +
      '//' +
      window.location.hostname +
      ':' +
      process.env.VUE_APP_PORT +
      process.env.VUE_APP_URL
    );
  }

  private formEncode(obj: { [key: string]: string}): string {
    const result = [];
    for (const key of Object.keys(obj)) {
      result.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
    return result.join('&');
  }

  private fetchWithBody(
    path: string,
    body: any,
    method: 'POST' | 'PUT' | 'DELETE',
  ) {
    return fetch(this.getUrl() + path, {
      method,
      body: JSON.stringify(body),
      headers: this.headers,
    }).then(result => {
      if (result.status >= 400) {
        throw new Error(result.statusText);
      }
      return result.json();
    });
  }
}

const AjaxCommons = new AjaxCommonsImpl();
export default AjaxCommons;
